import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { prepareCachedAppShell } from './serviceWorkerManager';

type WindowWithBootFallback = Window & {
  __freshClearBootFallbackTimer?: () => void;
  __freshClearCacheAndReload?: () => void;
  __freshRemoveBootLogPanel?: () => void;
};

const bootRetryTimeoutMs = 5000;

const setPreloaderRetryVisible = (visible: boolean) => {
  const retryButton = document.getElementById('app-preloader-retry');

  if (!retryButton) {
    return;
  }

  retryButton.classList.toggle('is-visible', visible);
};

const setPreloaderMessage = (title: string, text: string) => {
  const titleNode = document.getElementById('app-preloader-title');
  const textNode = document.getElementById('app-preloader-text');

  if (titleNode) {
    titleNode.textContent = title;
  }

  if (textNode) {
    textNode.textContent = text;
  }
};

const setPreloaderFile = (fileLabel: string) => {
  const fileNode = document.getElementById('app-preloader-file');

  if (fileNode) {
    fileNode.textContent = fileLabel;
  }
};

const attachPreloaderRetryHandler = () => {
  const retryButton = document.getElementById('app-preloader-retry');

  if (!retryButton) {
    return;
  }

  retryButton.onclick = () => {
    (window as WindowWithBootFallback).__freshClearCacheAndReload?.();
  };
};

const hidePreloader = () => {
  const preloader = document.getElementById('app-preloader');

  if (!preloader) {
    return;
  }

  setPreloaderRetryVisible(false);
  (window as WindowWithBootFallback).__freshRemoveBootLogPanel?.();
  preloader.classList.add('is-hidden');
  window.setTimeout(() => {
    preloader.remove();
  }, 320);
};

setPreloaderFile('Основной JavaScript загружен, запускаем интерфейс');
attachPreloaderRetryHandler();
const bootRetryTimeoutId = window.setTimeout(() => {
  const preloader = document.getElementById('app-preloader');

  if (!preloader || preloader.classList.contains('is-hidden')) {
    return;
  }

  setPreloaderMessage(
    'Загрузка',
    'Соединение заняло больше времени обычного. Можно попробовать перезапустить загрузку.'
  );
  setPreloaderFile('React загружен, приложение еще не завершило первый рендер');
  setPreloaderRetryVisible(true);
}, bootRetryTimeoutMs);

window.addEventListener('error', (event) => {
  const preloader = document.getElementById('app-preloader');

  if (!preloader || preloader.classList.contains('is-hidden')) {
    return;
  }

  const message = event.error instanceof Error
    ? event.error.message
    : event.message;

  setPreloaderMessage('Ошибка запуска', 'Интерфейс не смог запуститься.');
  setPreloaderFile(message ? `Ошибка: ${message}` : 'Ошибка JavaScript без сообщения');
  setPreloaderRetryVisible(true);
});

window.addEventListener('unhandledrejection', (event) => {
  const preloader = document.getElementById('app-preloader');

  if (!preloader || preloader.classList.contains('is-hidden')) {
    return;
  }

  const reason = event.reason instanceof Error
    ? event.reason.message
    : String(event.reason || '');

  setPreloaderMessage('Ошибка запуска', 'Интерфейс не смог завершить асинхронную загрузку.');
  setPreloaderFile(reason ? `Ошибка: ${reason}` : 'Асинхронная ошибка без сообщения');
  setPreloaderRetryVisible(true);
});

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    const message = event.data;

    if (!message || message.type !== 'PUSH_NOTIFICATION_NAVIGATE' || !message.url) {
      return;
    }

    const targetUrl = new URL(String(message.url), window.location.origin);

    if (targetUrl.origin !== window.location.origin) {
      return;
    }

    window.location.assign(`${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`);
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
setPreloaderFile('Рендерим React-приложение');
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

const finishBoot = () => {
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      (window as WindowWithBootFallback).__freshClearBootFallbackTimer?.();
      window.clearTimeout(bootRetryTimeoutId);
      hidePreloader();
    });
  });
};

finishBoot();
void prepareCachedAppShell();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
